/* tslint:disable */
/* eslint-disable */
export enum OrderPaymentStatus {
  New = 'NEW',
  Readytobecaptured = 'READYTOBECAPTURED',
  Captured = 'CAPTURED',
  Cancelled = 'CANCELLED',
  Notfound = 'NOTFOUND',
  Refund = 'REFUND'
}
